export default __webpack_public_path__ + "static/media/peels.e982bac0.pdf";